export const formatIDR = (n) => {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const formatNumber = (n) => Number(n || 0).toLocaleString("id-ID");

const BULAN = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
const BULAN_SHORT = ["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"];

export const formatDate = (iso, short = false) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return "-";
  const bulan = short ? BULAN_SHORT : BULAN;
  return `${d.getDate()} ${bulan[d.getMonth()]} ${d.getFullYear()}`;
};

export const daysLeft = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const now = new Date();
  return Math.ceil((d - now) / (1000 * 60 * 60 * 24));
};
